import { SubsidiaryIds } from "./SubsidiaryIds";

export const preferredCountries = [
  { v: "FI", t: "Suomi" },
  { v: "DK", t: "Denmark" },
  { v: "FR", t: "France" },
  { v: "DE", t: "Germany" },
  { v: "ES", t: "Spain" },
  { v: "SE", t: "Sweden" },
  { v: "NO", t: "Norway" },
  { v: "GB", t: "United Kingdom" },
  { v: "US", t: "United States" },
] as const;

const otherCountries = [
  { v: "AF", t: "Afghanistan" },
  { v: "AX", t: "Åland Islands" },
  { v: "AL", t: "Albania" },
  { v: "DZ", t: "Algeria" },
  { v: "AS", t: "American Samoa" },
  { v: "AD", t: "Andorra" },
  { v: "AO", t: "Angola" },
  { v: "AI", t: "Anguilla" },
  { v: "AG", t: "Antigua and Barbuda" },
  { v: "AR", t: "Argentina" },
  { v: "AM", t: "Armenia" },
  { v: "AW", t: "Aruba" },
  { v: "AU", t: "Australia" },
  { v: "AT", t: "Austria" },
  { v: "AZ", t: "Azerbaijan" },
  { v: "BS", t: "Bahamas" },
  { v: "BH", t: "Bahrain" },
  { v: "BD", t: "Bangladesh" },
  { v: "BB", t: "Barbados" },
  { v: "BE", t: "Belgium" },
  { v: "BZ", t: "Belize" },
  { v: "BJ", t: "Benin" },
  { v: "BM", t: "Bermuda" },
  { v: "BT", t: "Bhutan" },
  { v: "BO", t: "Bolivia, Plurinational State of" },
  { v: "BQ", t: "Bonaire, Sint Eustatius and Saba" },
  { v: "BA", t: "Bosnia and Herzegovina" },
  { v: "BW", t: "Botswana" },
  { v: "BV", t: "Bouvet Island" },
  { v: "BR", t: "Brazil" },
  { v: "IO", t: "British Indian Ocean Territory" },
  { v: "BN", t: "Brunei Darussalam" },
  { v: "BG", t: "Bulgaria" },
  { v: "BF", t: "Burkina Faso" },
  { v: "BI", t: "Burundi" },
  { v: "KH", t: "Cambodia" },
  { v: "CM", t: "Cameroon" },
  { v: "CA", t: "Canada" },
  { v: "IC", t: "Canary Islands" }, // Note: Not actual country code, but UPS requires this
  { v: "CV", t: "Cape Verde" },
  { v: "KY", t: "Cayman Islands" },
  { v: "CF", t: "Central African Republic" },
  { v: "TD", t: "Chad" },
  { v: "CL", t: "Chile" },
  { v: "CN", t: "China" },
  { v: "CX", t: "Christmas Island" },
  { v: "CC", t: "Cocos (Keeling) Islands" },
  { v: "CO", t: "Colombia" },
  { v: "KM", t: "Comoros" },
  { v: "CG", t: "Congo" },
  { v: "CD", t: "Congo, the Democratic Republic of the" },
  { v: "CK", t: "Cook Islands" },
  { v: "CR", t: "Costa Rica" },
  { v: "CI", t: "Côte d´Ivoire" },
  { v: "HR", t: "Croatia" },
  { v: "CW", t: "Curaçao" },
  { v: "CY", t: "Cyprus" },
  { v: "CZ", t: "Czech Republic" },
  { v: "DK", t: "Denmark" },
  { v: "DJ", t: "Djibouti" },
  { v: "DM", t: "Dominica" },
  { v: "DO", t: "Dominican Republic" },
  { v: "EC", t: "Ecuador" },
  { v: "EG", t: "Egypt" },
  { v: "SV", t: "El Salvador" },
  { v: "GQ", t: "Equatorial Guinea" },
  { v: "ER", t: "Eritrea" },
  { v: "EE", t: "Estonia" },
  { v: "ET", t: "Ethiopia" },
  { v: "FK", t: "Falkland Islands (Malvinas)" },
  { v: "FO", t: "Faroe Islands" },
  { v: "FJ", t: "Fiji" },
  { v: "FI", t: "Finland" },
  { v: "FR", t: "France" },
  { v: "GF", t: "French Guiana" },
  { v: "PF", t: "French Polynesia" },
  { v: "TF", t: "French Southern Territories" },
  { v: "GA", t: "Gabon" },
  { v: "GM", t: "Gambia" },
  { v: "GE", t: "Georgia" },
  { v: "DE", t: "Germany" },
  { v: "GH", t: "Ghana" },
  { v: "GI", t: "Gibraltar" },
  { v: "GR", t: "Greece" },
  { v: "GL", t: "Greenland" },
  { v: "GD", t: "Grenada" },
  { v: "GP", t: "Guadeloupe" },
  { v: "GU", t: "Guam" },
  { v: "GT", t: "Guatemala" },
  { v: "GG", t: "Guernsey" },
  { v: "GN", t: "Guinea" },
  { v: "GW", t: "Guinea-Bissau" },
  { v: "GY", t: "Guyana" },
  { v: "HT", t: "Haiti" },
  { v: "HM", t: "Heard Island and McDonald Islands" },
  { v: "VA", t: "Holy See (Vatican City State)" },
  { v: "HN", t: "Honduras" },
  { v: "HK", t: "Hong Kong" },
  { v: "HU", t: "Hungary" },
  { v: "IS", t: "Iceland" },
  { v: "IN", t: "India" },
  { v: "ID", t: "Indonesia" },
  { v: "IQ", t: "Iraq" },
  { v: "IE", t: "Ireland" },
  { v: "IM", t: "Isle of Man" },
  { v: "IL", t: "Israel" },
  { v: "IT", t: "Italy" },
  { v: "JM", t: "Jamaica" },
  { v: "JP", t: "Japan" },
  { v: "JE", t: "Jersey" },
  { v: "JO", t: "Jordan" },
  { v: "KZ", t: "Kazakhstan" },
  { v: "KE", t: "Kenya" },
  { v: "KI", t: "Kiribati" },
  { v: "KR", t: "Korea, Republic of" },
  { v: "KW", t: "Kuwait" },
  { v: "KG", t: "Kyrgyzstan" },
  { v: "LA", t: "Lao People´s Democratic Republic" },
  { v: "LV", t: "Latvia" },
  { v: "LB", t: "Lebanon" },
  { v: "LS", t: "Lesotho" },
  { v: "LR", t: "Liberia" },
  { v: "LI", t: "Liechtenstein" },
  { v: "LT", t: "Lithuania" },
  { v: "LU", t: "Luxembourg" },
  { v: "MO", t: "Macao" },
  { v: "MK", t: "Macedonia, the Former Yugoslav Republic of" },
  { v: "MG", t: "Madagascar" },
  { v: "MW", t: "Malawi" },
  { v: "MY", t: "Malaysia" },
  { v: "MV", t: "Maldives" },
  { v: "ML", t: "Mali" },
  { v: "MT", t: "Malta" },
  { v: "MH", t: "Marshall Islands" },
  { v: "MQ", t: "Martinique" },
  { v: "MR", t: "Mauritania" },
  { v: "MU", t: "Mauritius" },
  { v: "YT", t: "Mayotte" },
  { v: "MX", t: "Mexico" },
  { v: "FM", t: "Micronesia, Federated States of" },
  { v: "MD", t: "Moldova, Republic of" },
  { v: "MC", t: "Monaco" },
  { v: "MN", t: "Mongolia" },
  { v: "ME", t: "Montenegro" },
  { v: "MS", t: "Montserrat" },
  { v: "MA", t: "Morocco" },
  { v: "MZ", t: "Mozambique" },
  { v: "NA", t: "Namibia" },
  { v: "NR", t: "Nauru" },
  { v: "NP", t: "Nepal" },
  { v: "NL", t: "Netherlands" },
  { v: "NC", t: "New Caledonia" },
  { v: "NZ", t: "New Zealand" },
  { v: "NI", t: "Nicaragua" },
  { v: "NE", t: "Niger" },
  { v: "NG", t: "Nigeria" },
  { v: "NU", t: "Niue" },
  { v: "NF", t: "Norfolk Island" },
  { v: "MP", t: "Northern Mariana Islands" },
  { v: "NO", t: "Norway" },
  { v: "OM", t: "Oman" },
  { v: "PK", t: "Pakistan" },
  { v: "PW", t: "Palau" },
  { v: "PS", t: "Palestine, State of" },
  { v: "PA", t: "Panama" },
  { v: "PG", t: "Papua New Guinea" },
  { v: "PY", t: "Paraguay" },
  { v: "PE", t: "Peru" },
  { v: "PH", t: "Philippines" },
  { v: "PN", t: "Pitcairn" },
  { v: "PL", t: "Poland" },
  { v: "PT", t: "Portugal" },
  { v: "PR", t: "Puerto Rico" },
  { v: "QA", t: "Qatar" },
  { v: "RE", t: "Réunion" },
  { v: "RO", t: "Romania" },
  { v: "RW", t: "Rwanda" },
  { v: "BL", t: "Saint Barthélemy" },
  { v: "SH", t: "Saint Helena, Ascension and Tristan da Cunha" },
  { v: "KN", t: "Saint Kitts and Nevis" },
  { v: "LC", t: "Saint Lucia" },
  { v: "MF", t: "Saint Martin (French part)" },
  { v: "PM", t: "Saint Pierre and Miquelon" },
  { v: "VC", t: "Saint Vincent and the Grenadines" },
  { v: "WS", t: "Samoa" },
  { v: "SM", t: "San Marino" },
  { v: "ST", t: "Sao Tome and Principe" },
  { v: "SA", t: "Saudi Arabia" },
  { v: "SN", t: "Senegal" },
  { v: "RS", t: "Serbia" },
  { v: "SC", t: "Seychelles" },
  { v: "SL", t: "Sierra Leone" },
  { v: "SG", t: "Singapore" },
  { v: "SX", t: "Sint Maarten (Dutch part)" },
  { v: "SK", t: "Slovakia" },
  { v: "SI", t: "Slovenia" },
  { v: "SB", t: "Solomon Islands" },
  { v: "SO", t: "Somalia" },
  { v: "ZA", t: "South Africa" },
  { v: "GS", t: "South Georgia and the South Sandwich Islands" },
  { v: "SS", t: "South Sudan" },
  { v: "ES", t: "Spain" },
  { v: "LK", t: "Sri Lanka" },
  { v: "SR", t: "Suriname" },
  { v: "SJ", t: "Svalbard and Jan Mayen" },
  { v: "SZ", t: "Swaziland" },
  { v: "SE", t: "Sweden" },
  { v: "CH", t: "Switzerland" },
  { v: "TW", t: "Taiwan, Province of China" },
  { v: "TJ", t: "Tajikistan" },
  { v: "TZ", t: "Tanzania, United Republic of" },
  { v: "TH", t: "Thailand" },
  { v: "TL", t: "Timor-Leste" },
  { v: "TG", t: "Togo" },
  { v: "TK", t: "Tokelau" },
  { v: "TO", t: "Tonga" },
  { v: "TT", t: "Trinidad and Tobago" },
  { v: "TN", t: "Tunisia" },
  { v: "TR", t: "Turkey" },
  { v: "TM", t: "Turkmenistan" },
  { v: "TC", t: "Turks and Caicos Islands" },
  { v: "TV", t: "Tuvalu" },
  { v: "UG", t: "Uganda" },
  { v: "UA", t: "Ukraine" },
  { v: "AE", t: "United Arab Emirates" },
  { v: "GB", t: "United Kingdom" },
  { v: "US", t: "United States" },
  { v: "UM", t: "United States Minor Outlying Islands" },
  { v: "UY", t: "Uruguay" },
  { v: "UZ", t: "Uzbekistan" },
  { v: "VU", t: "Vanuatu" },
  { v: "VN", t: "Viet Nam" },
  { v: "VG", t: "Virgin Islands, British" },
  { v: "VI", t: "Virgin Islands, U.S." },
  { v: "WF", t: "Wallis and Futuna" },
  { v: "EH", t: "Western Sahara" },
  { v: "ZM", t: "Zambia" },
  { v: "ZW", t: "Zimbabwe" },
] as const;

export const allCountries = [...preferredCountries, ...otherCountries] as const;

export type CountryCode = (typeof allCountries)[number]["v"];

export const allCountriesWithEmptyOption = [
  ...preferredCountries,
  { v: "", t: "-------------" },
  ...otherCountries,
] as const;

export type CountryCodeWithEmptyOption = "" | CountryCode;

export const euCountries: CountryCode[] = [
  "AT", // Austria
  "BE", // Belgium
  "BG", // Bulgaria
  "HR", // Croatia
  "CY", // Cyprus
  "CZ", // Czechia
  "DK", // Denmark
  "EE", // Estonia
  "FI", // Finland
  "FR", // France
  "DE", // Germany
  "GR", // Greece
  "HU", // Hungary
  "IE", // Ireland
  "IT", // Italy
  "LV", // Latvia
  "LT", // Lithuania
  "LU", // Luxembourg
  "MT", // Malta
  "NL", // Netherlands
  "PL", // Poland
  "PT", // Portugal
  "RO", // Romania
  "SK", // Slovakia
  "SI", // Slovenia
  "ES", // Spain
  "SE", // Sweden
];

export type Country = {
  v: CountryCode;
  t: string;
};

export const usSubsidiaryCountries = [
  { v: "US", t: "United States" },
  { v: "AS", t: "American Samoa" },
  { v: "GU", t: "Guam" },
  { v: "MP", t: "Northern Mariana Islands" },
  { v: "PR", t: "Puerto Rico" },
  { v: "VI", t: "Virgin Islands, U.S." },
] as const satisfies readonly Country[];

export type UsSubsidiaryCountryCode =
  (typeof usSubsidiaryCountries)[number]["v"];

export const usSubsidiaryCountryCodes = usSubsidiaryCountries.map(
  (country) => country.v,
);

const usSubsidiaryCountryCodeSet = new Set<string>(usSubsidiaryCountryCodes);

const defaultCountryListForSubsidiary = allCountries.filter(
  (country) => !usSubsidiaryCountryCodeSet.has(country.v),
);

/** U.S. territories and associated areas under the USA subsidiary (excludes mainland US). */
export function isUsTerritoryCountryCode(
  countryCode: string | undefined,
): boolean {
  if (!countryCode) {
    return false;
  }

  return usSubsidiaryCountryCodeSet.has(countryCode) && countryCode !== "US";
}

export function countryList(): readonly Country[] {
  return allCountries;
}

export function countryListForSubsidiary(
  subsidiaryId: string | undefined,
): readonly Country[] {
  if (subsidiaryId === SubsidiaryIds.USA) {
    return usSubsidiaryCountries;
  }

  return defaultCountryListForSubsidiary;
}

export function isCountryAvailableForSubsidiary(
  countryCode: string | undefined,
  subsidiaryId: string | undefined,
): boolean {
  if (!countryCode) {
    return false;
  }

  return countryListForSubsidiary(subsidiaryId).some(
    (country) => country.v === countryCode,
  );
}

export function resolveCountryForSubsidiary(
  countryCode: string | undefined,
  subsidiaryId: string | undefined,
): string {
  if (!countryCode) {
    return "";
  }

  return isCountryAvailableForSubsidiary(countryCode, subsidiaryId)
    ? countryCode
    : "";
}

export function getCountryName(
  countryCode: string | null | undefined,
): string | undefined {
  if (!countryCode) {
    return undefined;
  }
  let result: string | undefined = undefined;
  const countryData = countryList().find((item) => item.v === countryCode);
  if (countryData) {
    result = countryData.t;
  }
  return result;
}
